





































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { vwDialogMixin, generalDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { OsdImage } from '@/types/api'
import { reqMan } from '@/singleton'
import OsdImagePreview from '@/components/OsdImage.vue'
import RadioIcon from '@/components/RadioIcon.vue'

export default mixins(generalDialogMixin).extend({
  components: {
    OsdImagePreview,
    RadioIcon
  },
  data (): {
    chosenImgId: number,
  } {
    return {
      chosenImgId: -1,
    }
  },
  computed: {
    imgList (): OsdImage[] { return this.$state.device.osd.imgList }
  },
  methods: {
    create () {
      this.$router.push({ name: `${this.$route.name}_create`})
    },
    edit (imgid: number) {
      this.$router.push({ name: `${this.$route.name}_edit`, params: {imgid: imgid + ''} })
    },
    deleteImg (imgid: number) {
      this.$router.push({ name: `${this.$route.name}_delete`, params: {imgid: imgid + ''} })
    },
    apply () {
      this.$emit('imageSelect', this.chosenImgId)
      this.closeThisDialog()
    },
  },
  mounted () {
    reqMan.ensureWsAvailable(() => {
      easyapi.getOsdAndImageList().then(() => {
        this.chosenImgId = ~~this.$route.query['selected_img_id']
        setTimeout(() => console.log('refs', this.$refs.imgPreviews), 1000)
      })
    })
  }
})
